// extracted by mini-css-extract-plugin
export var acceptButton = "_1r-5";
export var fullContent = "_1r-4";
export var link = "_1r-6";
export var linkIcon = "_1r-7";
export var sideContent = "_1r-3";
export var sideImage = "_1r-2";
export var sideImageWrapper = "_1r-1";
export var splitLayout = "_1r-0";